// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"ef103cd8","350":"cdc537bf","357":"67ab7e46","381":"ad9d339f","453":"68693753","587":"5752c768","669":"d22a928f","715":"450c9a0e","743":"0341fb73","929":"8dda2760","951":"32744aab"}[chunkId] + ".chunk.js";
};